import React from 'react';
import { useTranslation } from 'react-i18next';

import useResonanceMessagesListSize from '../../../../../../hooks/useResonanceMessagesListSize';
import useResonanceMessagesListSort from '../../../../../../hooks/useResonanceMessagesListSort';
import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import SortDropdown from '../../../../../../components/sort-dropdown/SortDropdown';
import CommonDropdown from '../../../../../../components/common-dropdown/CommonDropdown';
import useResonanceMessagesLinkSort from '../../../../../../hooks/useResonanceMessagesLinkSort';
import SearchInput from '../../../../../../components/common-inputs/SearchInput';
import ClusterRespondentsValue from '../../../../cluster-respondents-value/ClusterRespondentsValue';
import useResonanceLoadingState from '../../../../../hooks/useResonanceLoadingState';

import scss from '../TopMessages.module.scss';

function TopMessagesTableFilters({
  onSizeChange,
  onSortChange,
  size,
  sort,
  isFiltersApplied,
  clusterRespondents,
  search,
  onSearch,
}) {
  const { t } = useTranslation('resonance');

  const isMessagesLoading = useResonanceLoadingState('isMessagesLoading');

  const sizeOptions = useResonanceMessagesListSize();
  const messageSortOptions = useResonanceMessagesListSort();
  const linksSortOptions = useResonanceMessagesLinkSort();

  const handleChangeSort = ({ sort, direction }) => {
    const getSortValue = (isFiltersApplied ? linksSortOptions : messageSortOptions).find(
      ({ value }) => value === sort,
    )?.getSortValue;

    onSortChange({ sort, direction, getSortValue });
  };

  return (
    <div className={scss.tableFilters}>
      <div className={scss.filtersColumn}>
        <ClusterRespondentsValue clusterRespondents={clusterRespondents} />
      </div>

      <div className={scss.filtersColumn}>
        <WithLabel label={`${t('search')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={260}>
          <SearchInput
            value={search}
            onChange={onSearch}
            disabled={isMessagesLoading}
            size='sm'
            name='top-messages-search'
          />
        </WithLabel>

        <WithLabel label={`${t('sort')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={200}>
          <SortDropdown
            options={isFiltersApplied ? linksSortOptions : messageSortOptions}
            sort={sort?.sort}
            direction={sort?.direction}
            onChange={handleChangeSort}
            disabled={isMessagesLoading}
            name='top-messages-sort'
            closeOnApply
          />
        </WithLabel>

        <WithLabel variant={LABEL_STYLES.ROW} label={`${t('size')}:`} isBold maxWidth={140}>
          <CommonDropdown
            value={size}
            options={sizeOptions}
            onSelect={onSizeChange}
            disabled={isMessagesLoading}
            name='top-messages-size'
          />
        </WithLabel>
      </div>
    </div>
  );
}

export default TopMessagesTableFilters;
